import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view glass-card">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Adil Jeddi Radja </span>
            from <span className="purple"> Indonesia.</span>
            <br />
            I'm a Computer Science graduate from Politeknik Negeri Lampung, Indonesia. Beyond my formal education, I've gained practical experience through Enigmacamp Malang's bootcamp and numerous personal and group projects.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Foodie adventures
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Age doesn't matter. If you've got a dream, go for it"{" "}
          </p>
          <footer className="blockquote-footer">Monkey D Luffy</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
